import Vue from 'vue'
import Router from 'vue-router'
import UserSignIn from '@/pages/user/UserSignIn'
import UserTodo from '@/pages/user/UserTodo'
import UserInvite from '@/pages/user/UserInvite'
import UserInviteNew from '@/pages/user/UserInviteNew'
import PrivacyPolicy from '@/pages/doc/PrivacyPolicy'
import UserAgreement from '@/pages/doc/UserAgreement'
import MyMoneyBag from '@/pages/doc/MyMoneyBag'
import UserAccountMove from '@/pages/user/UserAccountMove'
import AccountMoveConfirm from '@/pages/user/AccountMoveConfirm'
import HelpIndex from '@/pages/help/HelpIndex'
import Help10 from '@/pages/help/Help10'
import Help20 from '@/pages/help/Help20'
import Help30 from '@/pages/help/Help30'
import Help40 from '@/pages/help/Help40'
import Help50 from '@/pages/help/Help50'
import Help60 from '@/pages/help/Help60'
import Help70 from '@/pages/help/Help70'
import UserShareInvite from '@/pages/share/UserShareInvite'
import GetCouponShareInvite from '@/pages/share/GetCouponShareInvite'
import TopUpRecharge from '@/pages/topUpRecharge/topUpRecharge'
import Binding from '@/pages/topUpRecharge/binding'
import devicetest from '../pages/device/devicetest'
import intelligentLock from '@/pages/intelligentLock/intelligentLock'
import lockcard from '@/pages/intelligentLock/lockcard' // 智能锁卡片
import caroutApplyfor from '@/pages/intelligentLock/caroutApplyfor' // 退卡申请
import carchangeApplyfor from '@/pages/intelligentLock/carchangeApplyfor' // 补换卡申请
import payDeposit from '@/pages/intelligentLock/payDeposit' // 交押金
import payDepositForm from '@/pages/intelligentLock/payDepositForm' // 交押金表单

import washClothes from '@/pages/washingMachine/washClothes'
import washercard from '@/pages/washingMachine/washercard' // 洗衣机卡片
import carChange from '@/pages/washingMachine/carChange' // 洗衣机换卡
import carOut from '@/pages/washingMachine/carOut' // 洗衣机换卡


import InquireelectricityNum from '@/pages/electricCharge/inquireelectricityNum' // 电表查询
import ToUpElectricCharge from '@/pages/electricCharge/toUpElectricCharge' // 电费
import PlayElectricityBill from '@/pages/electricCharge/playElectricityBill' // 电费支付

import ActivityPage from '@/pages/activity/unionpay' // 电费支付

import ZHDUserBind from '@/pages/user/ZHDUserBind'  // 学校一卡通绑定



Vue.use(Router)

export default new Router({
  routes: [
    { path: '/', redirect: '/electricCharge/inquireelectricityNum' },
    {
      path: '/intelligentLock/portal',
      name: 'intelligentLock',
      component: intelligentLock,
      meta: { title: '智能锁门卡业务' }
    },
    {
      path: '/intelligentLock/lockcard',
      name: 'lockcard',
      component: lockcard,
      meta: { title: '我的门卡' }
    },
    {
      path: '/intelligentLock/caroutApplyfor',
      name: 'caroutApplyfor',
      component: caroutApplyfor,
      meta: { title: '退押金' }
    },
    {
      path: '/intelligentLock/carchangeApplyfor',
      name: 'carchangeApplyfor',
      component: carchangeApplyfor,
      meta: { title: '补换卡' }
    },
    {
      path: '/intelligentLock/payDeposit',
      name: 'payDeposit',
      component: payDeposit,
      meta: { title: '交押金' }
    },
    {
      path: '/intelligentLock/payDepositForm',
      name: 'payDepositForm',
      component: payDepositForm,
      meta: { title: '交押金' }
    },

    {
      path: '/washingMachine/portal',
      name: 'washClothes',
      component: washClothes,
      meta: { title: '轻客一卡通业务' }
    },
    {
      path: '/washingMachine/washercard',
      name: 'washercard',
      component: washercard,
      meta: { title: '我的卡包' }
    },
    {
      path: '/washingMachine/carChange',
      name: 'carChange',
      component: carChange,
      meta: { title: '换卡' }
    },
    {
      path: '/washingMachine/carOut',
      name: 'carOut',
      component: carOut,
      meta: { title: '退卡' }
    },

    {
      path: '/device/devicetest',
      name: 'devicetest',
      component: devicetest,
      meta: { title: '创维轻客+' }
    },
    {
      path: '/topUpRecharge/topUpRecharge',
      name: 'TopUpRecharge',
      component: TopUpRecharge,
      meta: { title: '卡充值' }
    },
    {
      path: '/topUpRecharge/binding',
      name: 'Binding',
      component: Binding,
      meta: { title: '卡绑定' }
    },

    {
      path: '/electricCharge/inquireelectricityNum',
      name: 'InquireelectricityNum',
      component: InquireelectricityNum,
      meta: { title: '智能水电管控平台' }

    },
    {
      path: '/electricCharge/toUpElectricCharge',
      name: 'ToUpElectricCharge',
      component: ToUpElectricCharge,
      meta: { title: '智能水电管控平台' }

    },
    {
      path: '/electricCharge/playElectricityBill',
      name: 'PlayElectricityBill',
      component: PlayElectricityBill,
      meta: { title: '电费支付' }

    },

    {
      path: '/help/index',
      name: 'HelpIndex',
      component: HelpIndex,
      meta: { title: '帮助' }
    },
    {
      path: '/help/help10',
      name: 'Help10',
      component: Help10,
      meta: { title: '帮助' }
    },
    {
      path: '/help/Help20',
      name: 'Help20',
      component: Help20,
      meta: { title: '帮助' }
    },
    {
      path: '/help/Help30',
      name: 'Help30',
      component: Help30,
      meta: { title: '帮助' }
    },
    {
      path: '/help/Help40',
      name: 'Help40',
      component: Help40,
      meta: { title: '帮助' }
    },
    {
      path: '/help/Help50',
      name: 'Help50',
      component: Help50,
      meta: { title: '帮助' }
    },
    {
      path: '/help/Help60',
      name: 'Help60',
      component: Help60,
      meta: { title: '帮助' }
    },
    {
      path: '/help/Help70',
      name: 'Help70',
      component: Help70,
      meta: { title: '帮助' }
    },
    {
      path: '/doc/my-moneybag',
      name: 'MyMoneyBag',
      component: MyMoneyBag,
      meta: { title: '轻客充值及使用规则' }
    },
    {
      path: '/doc/user-agreement',
      name: 'UserAgreement',
      component: UserAgreement,
      meta: { title: '用户协议' }
    },
    {
      path: '/doc/privacy-policy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy,
      meta: { title: '隐私政策' }
    },
    {
      path: '/user/signin',
      name: 'UserSignIn',
      component: UserSignIn,
      meta: { title: '每日签到' }
    },
    {
      path: '/user/todo',
      name: 'UserTodo',
      component: UserTodo,
      meta: { title: '活动任务' }
    },
    {
      path: '/user/invite',
      name: 'UserInvite',
      component: UserInvite,
      meta: { title: '邀请有礼物' }
    },
    {
      path: '/user/accountmove',
      name: 'UserAccountMove',
      component: UserAccountMove,
      meta: { title: '账户迁移' }
    },
    {
      path: '/user/accountmoveconfirm',
      name: 'AccountMoveConfirm',
      component: AccountMoveConfirm,
      meta: { title: '账户迁移' }
    },
    {
      path: '/user/invitenew',
      name: 'UserInviteNew',
      component: UserInviteNew,
      meta: { title: '邀请有礼物' }
    },
    {
      path: '/usershare/invite',
      name: 'UserShareInvite',
      component: UserShareInvite,
      meta: { title: '邀请有礼-轻客注册' }
    },
    {
      path: '/usershare/get-coupon-share-invite',
      name: 'GetCouponShareInvite',
      component: GetCouponShareInvite,
      meta: { title: '创维轻客-扫码领取优惠券' }
    },
    {
      path: '/activity/h5/unionpay',
      name: 'ActivityPage',
      component: ActivityPage,
      meta: { title: '活动' }
    },
    {
      path: '/user/userBind',
      name: 'ZHDUserBind',
      component: ZHDUserBind,
      meta: { title: '浙海大一卡通信息绑定' }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js